import { render, staticRenderFns } from "./yy-header.vue?vue&type=template&id=2b07a440&"
import script from "./yy-header.vue?vue&type=script&lang=js&"
export * from "./yy-header.vue?vue&type=script&lang=js&"
import style0 from "./yy-header.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports